import '../services/services.css';
import './aboutUs.css';
const AboutUs = () => {
    return (
        <div className="cover w-100">
            {/* Hero Section */}
            <div className="service-hero-section text-white py-5 text-center bg-primary" id='about-us-hero'>
                <h1 className="display-4 fw-bold mb-3">About us</h1>
                <h3 className="text-white ">FORMER ENGINEERS TURNED BUSINESSMEN</h3>

            </div>
            <div className="container py-2">
               
                <div className="mb-5 about-us-div">
                    <h3 className="h4 fw-semibold mb-3 mt-4 text-center">WHY ‘PANORAMA’?</h3>
                    <p className="text-justify">
                        The meaning of the word panorama is ‘an unbroken view of the whole region surrounding an observer’. It all began in 2018, in a small room, when two best friends decided to quit their jobs and start their own venture. Initially all we could see was our life and the new avenues we could explore swirling around us, thus choosing the name “Panorama”.
                    </p>
                    <p className="text-justify">
                      We have all heard stories about great businesses beginning from one small room and a couple of enthusiastic dreamers. Today our company is filled with over 40 hardworking and skilled dreamers. We take pride in sharing all the same values such as: beneficence, non-maleficence, autonomy, justice, truth-telling and promise-keeping. All of us at Panorama are a team, sharing the same ethics and having each other's back.
                    </p>
                </div>

            </div>
        </div>
    );
};

export default AboutUs;
